import { render, staticRenderFns } from "./downSalaryAwardRule.vue?vue&type=template&id=5f8510c0&scoped=true&"
import script from "./downSalaryAwardRule.vue?vue&type=script&lang=js&"
export * from "./downSalaryAwardRule.vue?vue&type=script&lang=js&"
import style0 from "./downSalaryAwardRule.vue?vue&type=style&index=0&id=5f8510c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8510c0",
  null
  
)

export default component.exports